export default __webpack_public_path__ + "static/media/loader.a349b6a1.gif";